import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  DashboardClientScope,
  DashboardEnrollmentsAwaitingAcknowledgementItem
} from 'src/app/models/DashboardMetrics';
import { DashboardMetricsService } from 'src/app/services/dashboard-metrics.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { getErrorMessage } from 'src/app/utils/error-message';

@UntilDestroy()
@Component({
  selector: 'vex-enrollments-awaiting-acknowledgement-widget',
  templateUrl: './enrollments-awaiting-acknowledgement-widget.component.html',
  styleUrls: ['./enrollments-awaiting-acknowledgement-widget.component.scss']
})
export class EnrollmentsAwaitingAcknowledgementWidgetComponent implements OnChanges {
  @Input() scope: DashboardClientScope = 'mine';

  loading = false;
  items: DashboardEnrollmentsAwaitingAcknowledgementItem[] = [];

  constructor(
    private dashboardMetricsService: DashboardMetricsService,
    private snackbarService: SnackbarService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['scope']) {
      this.loadEnrollments();
    }
  }

  get emptyMessage(): string {
    return this.scope === 'all'
      ? 'No enrollments awaiting acknowledgement.'
      : 'No enrollments awaiting acknowledgement for your clients.';
  }

  pendingLabel(count: number): string {
    const noun = count === 1 ? 'enrollment' : 'enrollments';
    return `${count} web ${noun} pending client sign-off`;
  }

  private loadEnrollments(): void {
    this.loading = true;
    this.dashboardMetricsService.getEnrollmentsAwaitingAcknowledgement(this.scope)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (result) => {
          this.items = result.items ?? [];
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.items = [];
          this.snackbarService.open(
            getErrorMessage(err, 'Failed to load enrollments awaiting acknowledgement.'),
            'error'
          );
        }
      });
  }
}
